export const syncCommandBus = ({ middlewares }) => {
    const middlewareChain = createExecutionChain(middlewares);
    return async (command) => await middlewareChain(command);
};
const createExecutionChain = (middlewares) => middlewares.reduce((lastCallable, middleware) => async (command) => await middleware(command, lastCallable), () => Promise.resolve());
